import React, {Suspense, useEffect, useState} from "react";
import {ProvideAuth} from "./services/use-auth.js";
import {BrowserRouter as Router} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import './assets/styles/main.scss';
import Routes from "./Routes";
import {applyLocale, applyUserLocale, getCurrentLocale, resolveGuestLocale} from "./services/locale";
import {installLocaleAwareFetch} from "./services/fetch-locale";

export default function App () {
    const [appData, setAppData] = useState({});
    const [isAppDataLoaded, setIsAppDataLoaded] = useState(false);

    useEffect(() => {
        installLocaleAwareFetch(() => getCurrentLocale());
        applyLocale(resolveGuestLocale());

        fetch('/api/v1/appData')
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Cannot load app data');
                }

                return res.json();
            })
            .then((result) => {
                if (result && typeof result === 'object') {
                    setAppData(result);
                    if (result?.user) {
                        applyUserLocale(result.user);
                    }

                    return;
                }

                setAppData({});
            })
            .catch(() => {
                setAppData({});
            })
            .finally(() => {
                setIsAppDataLoaded(true);
            });
    }, [])

    return (
        isAppDataLoaded ?
            <Suspense fallback="loading">
                <ProvideAuth user={appData?.user || null}>
                    <Router>
                        <Header />
                        <div id="main">
                            <Routes />
                        </div>
                        <Footer />
                    </Router>
                </ProvideAuth>
            </Suspense> :
            <></>
    );
}
